import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import SubscriptionPlanContentsItem from '../molecules/SubscriptionPlanContentsItem';
import ModalGoing from '../modal/ModalGoing';
import ModalBack from '../modal/ModalComingBack';
import { setStayNights } from '../../modules/hotel';
import {
  handleDeletePlan,
  handleUpdateCheckin,
  handleUpdateQuestion,
} from '../../modules/planDetail';
import { getDaysToNextPlan } from '../../utils/plans';
import SearchHotelSP from './SearchHotelSP';

const selector = (state) => ({
  flight: state.flight,
  // hotel: state.hotel,
  // planDetail: state.planDetail,
});

const SubscriptionPlanContents = ({
  editingAccommodation,
  toggleEditingFlights,
  toggleEditingAccommodation,
  tripTotalDays,
  schedule,
  plans,
  maxStayNights,
  setMaxStayNights,
  planStartDate,
  setPlanStartDate,
  planIndex,
  setPlanIndex,
  planEndDate,
  questionAndAnswers,
  onQuestionAnswerChange,
}) => {
  const dispatch = useDispatch();
  const { flight } = useSelector(selector);
  const {
    selectedOutboundFlight,
    selectedInboundFlight,
  } = flight;

  const [ modalGoing, setModalGoing ] = useState(false);
  const [ modalBack, setModalBack ] = useState(false);

  const toggleModalGoing = useCallback(
    () => {
      setModalGoing(!modalGoing);
      toggleEditingFlights();
    },
    [ modalGoing ],
  );

  const toggleModalBack = useCallback(
    () => {
      setModalBack(!modalBack);
      toggleEditingFlights();
    },
    [ modalBack ],
  );

  if (editingAccommodation) {
    return (
      <SearchHotelSP
        maxStayNights={maxStayNights}
        planIndex={planIndex}
        planStartDate={planStartDate}
        toggleEditingAccommodation={toggleEditingAccommodation}
        editingAccommodation={editingAccommodation}
      />
    );
  }

  const handlePlanChange = (planIndex, startDate, maxStayNights) => {
    dispatch(setStayNights(maxStayNights));
    setPlanStartDate(startDate);
    setMaxStayNights(maxStayNights);
    setPlanIndex(planIndex);
    toggleEditingAccommodation();
  }
  const handlePlanDelete = (startDate) => {
    const confirm = window.confirm("削除してよろしいですか？");
    if (confirm) {
      dispatch(handleDeletePlan(startDate));
    }
  };

  const minDateInbound = moment(planEndDate).add(1, 'days').format('YYYY-MM-DD');

  return (
    <React.Fragment>
      <div className="subscriptionPlanContentsContainer">
        {schedule && schedule.map((s, i) => {
          const dateDisplay = s.date.format('YYYY年M月D日');

          const outboundFlight = i === 0 ? selectedOutboundFlight : null;
          const inboundFlight = i === tripTotalDays - 1 ? selectedInboundFlight : null;

          const index = i + 1;

          const { plan, planOptions } = s;

          const maxStayNights = getDaysToNextPlan(s.date, plans) || schedule.length - index;
          const startDate = s.date.format('YYYY-MM-DD');

          return (
            <SubscriptionPlanContentsItem
              key={index}
              index={index}
              outboundFlight={outboundFlight}
              inboundFlight={inboundFlight}
              dateDisplay={dateDisplay}
              plan={plan}
              handleOutboundFlightChange={toggleModalGoing}
              handleInboundFlightChange={toggleModalBack}
              handlePlanChange={() => handlePlanChange(index, startDate, maxStayNights)}
              handlePlanDelete={() => handlePlanDelete(startDate)}
              cantChangeHotel={!(plan && plan.firstDay)}
              cantDeleteHotel={index === 1}
              handleUpdateCheckin={(checkin) => dispatch(handleUpdateCheckin(checkin, startDate))}
              hideCheckin={!(plan && plan.firstDay)}
              handleUpdateQuestion={(title, selected) => dispatch(handleUpdateQuestion(title, selected, startDate))}
              showQuestions={!!(plan && plan.firstDay)}
              hideMessage={!(plan && plan.firstDay)}
              planOptions={planOptions}
              questionAndAnswers={questionAndAnswers}
              onQuestionAnswerChange={onQuestionAnswerChange}
              previousIsPlanOption={!!(planOptions && planOptions.length)}
            />
          );
        })}
      </div>
      <ModalGoing open={modalGoing} onClose={toggleModalGoing} hideConnectingFlightCheckBox={true} />
      <ModalBack open={modalBack} onClose={toggleModalBack} calenderMinDate={minDateInbound} hideConnectingFlightCheckBox={true} />
    </React.Fragment>
  );
};

SubscriptionPlanContents.propTypes = {
  editingAccommodation: PropTypes.bool.isRequired,
  toggleEditingFlights: PropTypes.func.isRequired,
  toggleEditingAccommodation: PropTypes.func.isRequired,
  tripTotalDays: PropTypes.number.isRequired,
  schedule: PropTypes.array.isRequired,
  plans: PropTypes.array.isRequired,
  maxStayNights: PropTypes.number,
  setMaxStayNights: PropTypes.func.isRequired,
  planStartDate: PropTypes.string,
  setPlanStartDate: PropTypes.func.isRequired,
  planIndex: PropTypes.number,
  setPlanIndex: PropTypes.func.isRequired,
  planEndDate: PropTypes.string,
  questionAndAnswers: PropTypes.array,
  onQuestionAnswerChange: PropTypes.func,
};

export default SubscriptionPlanContents;
